import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "flow_token";
export const HQ_TOKEN_KEY = "flow_hq_token";

export const api = axios.create({ baseURL: API, timeout: 60000 });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && (window.location.pathname.startsWith("/app") || window.location.pathname.startsWith("/hq")) && !window.location.pathname.startsWith("/app/login")) {
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = "/app/login";
    }
    return Promise.reject(err);
  },
);

export const publicApi = axios.create({ baseURL: API, timeout: 60000 });

export const mediaUrl = (m) => (m?.url ? `${BACKEND_URL}${m.url}` : "");

export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(", ");
  return e?.message || fallback;
};

export const appOrigin = () => window.location.origin;

/** Fetch a signed-in file (PDF etc.) and hand it to the browser — opens in a new tab, falls back to download. */
export const openAuthedFile = async (path, filename) => {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const win = window.open(url, "_blank", "noopener");
  if (!win) {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "file.pdf";
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};
